module.exports = __webpack_public_path__ + "994c6ecdd3d68623e06452f4daa84f10.MP3";